<template>
  <div id="bet-card" v-if="$isAgent()">
    <v-card class="white black--text mx-auto pt-1" flat>
      <!-- 
        Header "Print Only" 
      -->
      <div class="d-none d-print-block">
        <h2 class="text-center">{{ $store.state.operators.operator_name }}</h2>
        <hr />
        <v-row no-gutters>
          <v-col cols="6">
            <div class="overline pa-0">{{ $t("code") }}</div>
            <div class="pa-0 caption">{{ bet.id }}</div>
            <div class="overline pa-0">{{ $t("agent") }}</div>
            <div class="pa-0 caption">
              {{
                $store.state.logged.status
                  ? $store.state.logged.data.nome_usuario
                  : ""
              }}
            </div>
            <div class="overline pa-0">{{ $t("phone") }}</div>
            <div class="pa-0 caption">
              {{
                $store.state.logged.status ? $store.state.logged.data.phone : ""
              }}
            </div>
          </v-col>
          <v-col cols="6">
            <div class="overline pa-0">{{ $t("schedule") }}</div>
            <div class="pa-0 caption">
              {{ bet.date | dateFormat }} <br />{{ $gmt() }}
            </div>
            <div class="overline pa-0">{{ $t("type") }}</div>
            <div class="pa-0 caption">
              {{ bet.n_events | typeBet }} {{ bet.printed | via }}
            </div>
            <div class="overline pa-0">{{ $t("client") }}</div>
            <div class="pa-0 caption">{{ bet.punter }}</div>
          </v-col>
        </v-row>
        <hr />
      </div>
      <!-- 
        / End: Header "Print Only" 
      -->

      <v-toolbar light flat tile class="flex-grow-0 d-print-none">
        <h3 class="font-weight-black">
          <div class="cursor-pointer" @click="$copy(bet.id)">
            Nº {{ bet.id }} <v-icon size="18">mdi-content-copy</v-icon>
          </div>
          <span class="caption">{{ $t("client") }}: {{ bet.punter }}</span>
        </h3>
        <div class="flex-grow-1"></div>
        <div class="pt-1 text-right" style="font-size: 12px">
          {{ bet.date | dateFormat }} <br />
          {{ $gmt() }}
        </div>
      </v-toolbar>
      <v-divider light class="d-print-none"></v-divider>
      <hr class="d-none d-print-block" />
      <v-card-text class="py-2 black--text">
        <v-subheader light class="px-0 d-flex justify-space-between">
          <div>{{ bet.n_events }} {{ $t("selection") }}</div>
          <div>odd</div>
        </v-subheader>
        <div>
          <div
            v-for="(event, index) in bet.events"
            :key="event.id"
            class="d-flex flex-column"
          >
            <v-divider
              light
              v-show="index"
              class="ml-8 pb-2 d-print-none"
            ></v-divider>
            <hr class="d-none d-print-block" />
            <div
              class="d-flex mb-2 pa-1"
              :style="event.odds_valid == '0' ? 'border: solid thin red' : ''"
              :class="event.odds_valid == '0' ? 'rounded pa-2' : ''"
            >
              <div class="pr-4 d-flex justify-center d-print-none">
                <v-icon light :color="!event.odds_valid ? 'red' : ''"
                  >mdi-circle-medium</v-icon
                >
              </div>
              <div class="flex-grow-1 d-flex flex-column mr-2 ">
                <div class="overline">
                  {{ event.category_name }} - {{ event.tournaments_name }}
                </div>

                <div class="subtitle-2 font-weight-bold">
                  {{ $infoTable.outcomes(event.id_outcome).name_outcome }}
                </div>
                <div class="caption">
                  {{ $t("market") }}:
                  {{ $infoTable.markets(event.id_market).name_market }}
                </div>
                <div class="caption">
                  {{ event.description }}
                </div>
                <div class="caption">{{ event.scheduled | dateFormat }}</div>
              </div>
              <div class="d-flex flex-column justify-center align-end">
                <!-- Pre-Bet = (status_bet = '2')  -->
                <div
                  :class="
                    bet.status_bet === '2'
                      ? 'text-decoration-line-through grey--text'
                      : 'font-weight-black'
                  "
                >
                  {{ event.factor_event }}
                </div>

                <!-- Pre-Bet = (status_bet = '2')  -->
                <div v-if="bet.status_bet === '2'" class="font-weight-black">
                  {{ event.odd_price }}
                </div>

                <div
                  class="font-weight-black"
                  v-html="
                    $infoTable.conference(
                      event.result_event,
                      event.status_event,
                      event.odds_valid
                    )
                  "
                ></div>

                <v-chip
                  v-if="event.live_event === '1'"
                  class="font-weight-black"
                  color="info"
                  x-small
                >
                  {{ $t("live") }}
                </v-chip>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-divider light class="d-print-none"></v-divider>
      <hr class="d-none d-print-block" />
      <v-card-actions>
        <div
          class="d-flex align-center justify-center pl-1 pr-3 pt-2"
          v-if="valueQrcode && !share_bet"
        >
          <qrcode-vue
            :value="valueQrcode"
            :size="sizeQrcode"
            level="H"
            renderAs="svg"
          ></qrcode-vue>
        </div>
        <div class="d-flex flex-grow-1 flex-column body-2">
          <div class="d-flex justify-space-between align-center">
            <div>{{ $t("totalOdds") }}</div>
            <div>
              <!-- Pre-Bet = (status_bet = '2')  -->
              <span
                :class="
                  bet.status_bet === '2'
                    ? 'text-decoration-line-through grey--text'
                    : 'font-weight-black'
                "
                >{{ bet.factor_bet }}</span
              >
              <!-- Pre-Bet = (status_bet = '2')  -->
              <span v-if="bet.status_bet === '2'" class="font-weight-black"
                >&nbsp; {{ current_factor }}</span
              >
            </div>
          </div>
          <div class="d-flex justify-space-between align-center">
            <div>{{ $t("value") }}</div>
            <div class="font-weight-black">{{ bet.amount }}</div>
          </div>
          <div class="d-flex justify-space-between align-center">
            <div>{{ $t("possibleReturn") }}</div>
            <div>
              <!-- Pre-Bet = (status_bet = '2')  -->
              <span
                :class="
                  bet.status_bet === '2'
                    ? 'text-decoration-line-through grey--text'
                    : 'font-weight-black'
                "
                >{{ bet.prize }}</span
              >
              <span v-if="bet.status_bet === '2'" class="font-weight-black"
                >&nbsp; {{ current_prize }}</span
              >
            </div>
          </div>
          <div
            class="d-flex justify-space-between align-center"
            v-if="agentPercentage && agentPercentage > 0"
          >
            <div>{{ $t("clientGains") }}</div>
            <div>
              <!-- Pre-Bet = (status_bet = '2')  -->
              <span
                :class="
                  bet.status_bet === '2'
                    ? 'text-decoration-line-through grey--text'
                    : 'font-weight-black'
                "
                >{{
                  (bet.prize - bet.prize * agentPercentage).toFixed(2)
                }}</span
              >
              <span v-if="bet.status_bet === '2'" class="font-weight-black"
                >&nbsp;
                {{
                  (current_prize - current_prize * agentPercentage).toFixed(2)
                }}</span
              >
            </div>
          </div>

          <div class="d-flex justify-space-between align-center">
            <div>{{ $t("conference") }}</div>
            <div
              class="font-weight-black"
              v-html="
                $infoTable.conference(
                  bet.result_bet,
                  bet.status_bet,
                  bet.odds_valid
                )
              "
            ></div>
          </div>
        </div>
      </v-card-actions>

      <!-- 
        Footer "Print Only" 
      -->
      <div class="d-none d-print-block caption">
        <hr />
        <div class="" v-if="bet.hash != ''">
          {{ bet.hash }}_{{ $route.path.split("/").pop() }}
        </div>
        <div class="">
          {{ $t("printTime") }}: {{ $date.get.localeDateTime() }}
        </div>
        <div class="">
          {{ $store.state.operators.regulation_print }}
        </div>
        <hr />
        <div class="text-center">
          <div>{{ $t("prohibitedForUnder18") }}</div>
          <br />
        </div>
      </div>
      <!-- 
        / End: Footer "Print Only" 
      -->
    </v-card>
  </div>
</template>
<script>
import QrcodeVue from "qrcode.vue";
export default {
  name: "betCard",
  components: {
    QrcodeVue,
  },
  data: () => ({
    sizeQrcode: 80,
    domain: "",
  }),
  mounted() {
    this.domain = this.$domain();
  },
  computed: {
    agentPercentage() {
      if (
        this.$store.state.operators &&
        this.$store.state.operators.retail == 1 &&
        this.$isAgent()
      ) {
        const agent = this.$store.state.betAgent;

        if (agent) {
          const { percentage_prize, events_prize } = agent;

          if (percentage_prize && events_prize) {
            if (percentage_prize > 0) {
              const bet_data = this.$store.state.betCard;

              if (bet_data && bet_data.events.length >= events_prize) {
                return percentage_prize / 100;
              } else {
                return 0;
              }
            } else {
              return 0;
            }
          }
        }
      }

      return 0;
    },
    logged() {
      return this.$store.state.logged;
    },
    // Bet
    bet() {
      return this.$store.state.betCard;
    },
    // mount qrcode
    valueQrcode() {
      if (this.bet.hash) {
        return `${this.bet.id}@${this.bet.hash.substring(0, 10)}`;
      } else {
        return false;
      }
    },
    // Current Factor (Only Pre-Bet)
    current_factor() {
      let events = this.bet.events;
      let current = 1;

      for (var i = 0; i < this.bet.events.length; i++) {
        current = current * Number(events[i].odd_price);
      }
      const { multi_max } = this.logged.data;
      const data = current > multi_max ? multi_max : current;
      return this.decimalAdjustment(data);
    },
    // Current Prize (Only Pre-Bet)
    current_prize() {
      let current = this.current_factor * this.bet.amount;
      const { max_prize } = this.logged.data;
      const data = current > max_prize ? max_prize : current;
      return this.decimalAdjustment(data);
    },
    // shareBet
    share_bet() {
      return this.$store.state.shareBet;
    },
  },
  methods: {
    decimalAdjustment: function(num) {
      return -(Math.round(-num + "e+2") + "e-2");
    },
  },
  filters: {
    dateFormat: function(val) {
      if (!val) {
        return;
      }
      var date = new Date(val.replace(" ", "T")).toLocaleString();
      return date;
    },
    typeBet: function(val) {
      const type = {
        1: "Simples",
        2: "Dupla",
        3: "Tripla",
      };
      if (val >= 4) return "Múltipla";
      return type[val];
    },
    via: function(val) {
      return val == 0 ? "" : "2ª via";
    },
  },
};
</script>
